/**
 * The bare loop path (OL-312) — `/orca/loops/<id>` redirects to that loop's
 * canvas.
 *
 * A loop has no page of its own: the canvas IS the loop page, with the
 * invocations tab beside it. Without this route the path 404s, which is what a
 * hand-typed, shared or truncated link lands on. The guard carries the id
 * through, so the redirect ends at the right loop; no component is registered
 * because nothing here ever renders.
 *
 * @since 1.0.0
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The redirect, extracted so it is unit-testable without the route machinery.
 *
 * @since 1.0.0
 */
export const loopRedirectBeforeLoad = ({ params }: { readonly params: { readonly loopId: string } }) => {
  throw redirect({ to: "/orca/loops/$loopId/canvas", params: { loopId: params.loopId } });
};

export const Route = createFileRoute("/orca/loops/$loopId/")({
  beforeLoad: loopRedirectBeforeLoad,
});
